import { inject, injectable } from 'inversify';

import { ApiGateway, TYPES as ApiGatewayTypes, HttpResponse } from '@desygner/ui-core-api-gateway';

export interface IRestrictionsService {
  getTemplatePermissions(encodedId: number): Promise<HttpResponse>;
}

@injectable()
export class RestrictionsService implements IRestrictionsService {
  constructor(
    @inject(ApiGatewayTypes.ApiGateway)
    private readonly apiGateway: ApiGateway
  ) {}

  public async getTemplatePermissions(encodedId: number): Promise<HttpResponse> {
    const companyId = this.apiGateway.company;

    const requestUrl = `brand/companies/${companyId}/templates/${encodedId}/templatepermissions`;

    try {
      return await this.apiGateway.fetch('GET', requestUrl);
    } catch (error) {
      console.error('Error fetching template permissions:', error);
      throw error;
    }
  }
}
